<template>
    <span v-if="show" :class="className + ' error'">
        <slot name="errorMessage"></slot>
    </span>
</template>

<script>
    export default {
        name: "FormError",
        props: ['show', 'className']
    }
</script>

<style scoped lang="scss">

</style>